import i18n from "i18next";
import { supportEmail } from "@canucci/base/env";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enPages from "../locales/en/pages.json";
import svPages from "../locales/sv/pages.json";
import dePages from "../locales/de/pages.json";
import arPages from "../locales/ar/pages.json";
import daPages from "../locales/da/pages.json";
import noPages from "../locales/no/pages.json";
import fiPages from "../locales/fi/pages.json";
import enCommon from "../locales/en/common.json";
import svCommon from "../locales/sv/common.json";
import deCommon from "../locales/de/common.json";
import arCommon from "../locales/ar/common.json";
import daCommon from "../locales/da/common.json";
import noCommon from "../locales/no/common.json";
import fiCommon from "../locales/fi/common.json";
import fixedCommon from "../locales/fixed.json";
const resources = {
  en: {
    pages: enPages,
    fixed: fixedCommon,
    common: enCommon,
  },
  sv: {
    pages: svPages,
    fixed: fixedCommon,
    common: svCommon,
  },
  de: {
    pages: dePages,
    fixed: fixedCommon,
    common: deCommon,
  },
  ar: {
    pages: arPages,
    fixed: fixedCommon,
    common: arCommon,
  },
  da: {
    pages: daPages,
    fixed: fixedCommon,
    common: daCommon,
  },
  no: {
    pages: noPages,
    fixed: fixedCommon,
    common: noCommon,
  },
  fi: {
    pages: fiPages,
    fixed: fixedCommon,
    common: fiCommon,
  },
};

export const supportedLanguages = ["en", "sv", "de", "ar", "da", "no", "fi"];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    debug: process.env.NODE_ENV === "development",
    ns: ["pages", "fixed", "common"],
    defaultNS: "pages",

    interpolation: {
      escapeValue: false,
      // Address comes from config/runtime/.env.*; strings use {{supportEmail}}.
      defaultVariables: { supportEmail: supportEmail() },
    },

    react: {
      useSuspense: true,
    },
    compatibilityJSON: "v4", // Use v4 format for interpolation {{var}}
    // Configure detection to remove persistence
    detection: {
      // Order of detection methods, removing localStorage and cookie
      order: ["querystring", "navigator", "htmlTag"],
      // Keys for lookup
      lookupQuerystring: "lng",
      lookupSessionStorage: "i18nextLng",
      // Disable caching
      caches: [],
    },
  });

export default i18n;
